import React, { useState, useRef } from "react";
import axios from "axios";
import "./index.css";

const App = () => {
  const [imageURL, setImageURL] = useState(null);
  const [promt, setPrompt] = useState(undefined);
  const apiKey = `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`;
  const [isLoading, setLoading] = useState(false);

  async function generateImage(prompt) {
    setLoading(true);
    try {
      // Make a POST request to the OpenAI API
      const response = await axios.post(
        "https://api.openai.com/v1/images/generations",
        {
          prompt: prompt,
          model: "dall-e-3",
          size: `1024x1024`,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiKey}`,
          },
        }
      );
      console.log(response);
      const image_ = response?.data?.data?.[0]?.url;
      console.log("image_", image_);
      setImageURL(image_);
    } catch (error) {
      console.error("Error:", error.message);
    } finally {
      setLoading(false);
    }
  }

  const handleChange = (e) => {
    setPrompt(e.target.value);
  };

  const ref = useRef(undefined);
  const clear = () => {
    setImageURL(undefined);
    setPrompt(undefined);
    ref.current.value = "";
  };

  async function downloadImage(imageSrc, nameOfDownload = "my-image.png") {
    const response = await fetch(imageSrc);

    const blobImage = await response.blob();

    const href = URL.createObjectURL(blobImage);

    const anchorElement = document.createElement("a");
    anchorElement.href = href;
    anchorElement.download = nameOfDownload;

    document.body.appendChild(anchorElement);
    anchorElement.click();

    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(href);
  }

  return (
    <div style={{ padding: 30 }}>
      <textarea onChangeCapture={handleChange} rows="4" cols="50" ref={ref} />
      <div style={{ marginBottom: 20 }}>
        <button
          className="btn"
          style={{ marginRight: 12 }}
          onClick={() => generateImage(promt)}
        >
          {isLoading ? `Generating...` : `Generate`}
        </button>
        {imageURL && (
          <>
            <button className="btn" onClick={clear} style={{ marginRight: 12 }}>
              Clear
            </button>
          </>
        )}
      </div>
      {imageURL && (
        // eslint-disable-next-line jsx-a11y/img-redundant-alt
        <img
          style={{ display: "block", maxWidth: 500, objectFit: "contain" }}
          src={imageURL}
          alt="Generated Image"
        />
      )}
    </div>
  );
};

export default App;
